<template>
  <div>
    <div class="white-card">
      <div class="white-card-header">
        <div class="title-wrap">
          <label class="title-label">{{label.get('pay_rate')}}</label>
        </div>
        <button
            class="add-new-btn"
            type="button"
            @click="createNewPayRate"
        >
          <i class="atto atto-add-more" />
          {{label.get('add_pay_rate')}}
        </button>
      </div>
      <div class="pay-rate">
        <div class="card-content">
          <div class="d-flex align-items-center justify-content-between">
            <div class="check-wrapper switch-wrapper">
              <b-form-checkbox
                  v-model="member.user_settings.pay_rate_enabled"
                  @change="togglePayRate"
              >
                {{ label.get('enable_pay_rate') }}
              </b-form-checkbox>
              <p class="disclaimer">
                {{ label.get('enable_pay_rate_description') }}
              </p>
            </div>
          </div>
        </div>
        <div class="list-container" v-if="member.user_settings.pay_rate_enabled">
          <div class="table-heading">
            <span class="heading-label date">{{ label.get('date') }}</span>
            <span class="heading-label hourly-rate">{{ label.get('hourly-rate') }}</span>
          </div>
          <ul class="pay-rate-list">
            <li class="no-pay-rates" v-if="!payRates.length">
              <span>{{ label.get('no_pay_rates_have_been_added') }}</span>
            </li>

            <li
                v-for="(payRate, idx) in payRates"
                :key="idx"
            >
              <span class="date">Effective from  ·  {{ getFormattedEffectiveFrom(payRate.effective_from) }}</span>
              <span class="hourly-rate">${{ payRate.hourly_rate }}/h</span>
              <div class="customize-pay-rate">
                <button
                    class="edit"
                    @click="editPayRate(payRate)"
                >
                  <i class="atto atto-edit-btn" />
                </button>
                <button
                    class="delete"
                    @click="deletePayRate(payRate)"
                >
                  <i class="atto atto-delete" />
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <create-pay-rate-component
          :user-id="member.id"
          :pay-rates="payRates"
          v-if="showCreatePayRate"
      />
      <delete-pay-rate-component
          :pay-rate="payRateItem"
          v-if="showDeletePayRate" />
      <edit-pay-rate-component
          :pay-rate="payRateItem"
          :pay-rates="payRates"
          v-if="showEditPayRate" />
    </div>
  </div>
</template>

<script>
  import PayRateService from "../../services/PayRateService";
  import MemberService from "../../services/MemberService";
  import CreatePayRateComponent from "./CreatePayRateComponent";
  import DeletePayRateComponent from "./DeletePayRateComponent";
  import EditPayRateComponent from "./EditPayRateComponent";

  export default {
    name: "PayRatesComponent",
    components: {EditPayRateComponent, DeletePayRateComponent, CreatePayRateComponent},
    props: {
        member: {
          type: Object,
          default: {}
        }
    },
    data() {
      return {
        payRates : [],
        showCreatePayRate: false,
        showDeletePayRate: false,
        payRateItem: null,
        showEditPayRate: false
      }
    },
    mounted() {
      this.$root.$on('hideCreatePayRates', this.hideCreateNewPayRateModal);
      this.$root.$on('hideDeletePayRate', this.hideDeletePayRate);
      this.$root.$on('hideEditPayRate', this.hideEditPayRate);
      this.getPayRates();
    },
    beforeDestroy() {
      this.$root.$off('hideCreatePayRates');
      this.$root.$off('hideDeletePayRate');
      this.$root.$off('hideEditPayRate');
    },
    methods: {
      getFormattedEffectiveFrom(effectiveFrom) {
        return this.$moment(effectiveFrom).format('MMMM D, YYYY');
      },
      getPayRates() {
        const uid = this.$route.params.uid;
        this.$store.commit('showLoading');
        PayRateService.getList(uid).then((result) => {
          this.payRates = result;
          this.$store.commit('hideLoading');
        }).catch((error) => {
          this.$store.commit('hideLoading');
        });
      },
      togglePayRate() {
        this.member.user_settings.pay_rate_enabled =  !this.member.user_settings.pay_rate_enabled
        MemberService.updateMemberSettings(this.member.user_settings).then((result) => {
          this.$store.commit('hideLoading');
        }).catch((error) => {
          this.$store.commit('hideLoading');
        });
      },
      hideCreateNewPayRateModal(data){
        this.showCreatePayRate = false;
        if(data) {
          this.payRates.push(data);
        }
      },
      createNewPayRate(){
        this.showCreatePayRate = true;
      },
      deletePayRate(payRate){
        this.payRateItem = payRate;
        this.showDeletePayRate = true;
      },
      editPayRate(payRate){
        this.payRateItem = payRate;
        this.showEditPayRate = true;
      },
      hideDeletePayRate(payRate){
        this.showDeletePayRate = false;
        if(payRate) {
          const index = this.payRates.indexOf(payRate);
          this.payRates.splice(index, 1);
        }
      },
      hideEditPayRate(payRate) {
        if(payRate) {
          const index = this.payRates.indexOf(payRate);
          if(index >= 0) {
            this.payRates[index].userId = payRate.userId;
          }
        }
        this.showEditPayRate = false;
        this.payRateItem = null;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .pay-rate{
  .card-content{
    padding: 48px 24px 40px;

    .switch-wrapper{
      margin-left: 16px;
    }
    p.disclaimer{
      max-width: 400px;
      color: #666666;
      margin: 0;
    }
  }
  .table-heading{
    padding: 12px 244px 12px 80px !important;
    border-top: 1px solid $atto-light-grey !important;
  }
  span{
    &.date{
      min-width: 320px;
      width: 60%;
    }

    &.hourly-rate{
      min-width: 100px;
      width: 40%;
    }
  }
  ul.pay-rate-list{
    li{
      height: 50px;
      padding: 13px 244px 13px 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid $atto-light-grey;

      span{
        font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        color: $atto-font-color;
      }
      .customize-pay-rate{
        position: absolute;
        right: 32px;
        display: flex;

        button{
          color: $atto-dark-grey;
          font-size: 1.125rem;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;

          i{
            margin: 0;
          }

          &:hover{
            color: $atto-font-color;
            background-color: $atto-light-grey;
            border-radius: 100%;

            i{
              margin: 0;
              &:before{
                color: $atto-font-color;
              }
            }
          }
          &.delete{
            margin-right: 8px;
          }
        }
      }

      &.no-pay-rates{
        span{
          color: $atto-not-active;
        }
      }
    }
  }
}
</style>